(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mh-rsc-product-card"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__mhRscProductCardSwatchesBound) return;
  window.__mhRscProductCardSwatchesBound = true;

  function canHover() {
    return window.matchMedia && window.matchMedia("(min-width: 989px)").matches;
  }

  function activate(link) {
    var card = link.closest(".mh-rsc-product-card");
    if (!card) return;

    var wrap = link.querySelector(".mh-rsc-product-card__swatch-imgwrap");
    if (!wrap) return;

    var img360 = wrap.getAttribute("data-image");
    if (!img360) return;

    var mainImg = card.querySelector(".mh-rsc-product-card__media-img");
    if (!mainImg) return;

    // swap main product image
    mainImg.src = img360;
    mainImg.removeAttribute("srcset");
    mainImg.removeAttribute("sizes");

    // active state
    var all = card.querySelectorAll(".mh-rsc-product-card__swatch-link");
    Array.prototype.forEach.call(all, function (a) {
      var isActive = a === link;
      a.classList.toggle("mh-rsc-product-card__swatch-link--active", isActive);
      a.setAttribute("aria-current", isActive ? "true" : "false");
    });
  }

  // CLICK always (desktop + mobile)
  document.addEventListener("click", function (evt) {
    var a = evt.target.closest(".mh-rsc-product-card__swatch-link");
    if (!a) return;

    // allow open in new tab etc
    if (evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.altKey) return;

    evt.preventDefault();
    activate(a);
  });

  // HOVER only on desktop (>=989px)
  document.addEventListener("mouseover", function (evt) {
    if (!canHover()) return;

    var a = evt.target.closest(".mh-rsc-product-card__swatch-link");
    if (!a) return;

    activate(a);
  });

  /* -------------------------------------------------------
   * Swatch image fallback (reliable)
   * - Do NOT rely on <img onerror> because CDN may return 200.
   * - Instead, probe src2/src3 with a new Image().
   * - If none work, hide swatch img so bg-color shows.
   *
   * Requires your swatch <img> to have:
   *   data-src1="..."
   *   data-src2="..."
   *   data-src3="..."
   * ------------------------------------------------------ */

  function probe(url, cb) {
    if (!url) return cb(false);
    var test = new Image();
    test.onload = function () { cb(true); };
    test.onerror = function () { cb(false); };
    test.src = url;
  }

  function fixOneSwatchImg(img) {
    if (!img || img.getAttribute("data-swatch-fixed")) return;
    img.setAttribute("data-swatch-fixed", "1");

    var src1 = img.getAttribute("data-src1") || "";
    var src2 = img.getAttribute("data-src2") || "";
    var src3 = img.getAttribute("data-src3") || "";

    // If src is already a different one, respect it
    // But still ensure it's valid; if not, we try fallbacks.
    var current = img.currentSrc || img.src || "";

    // Prefer src2 if it differs from src1; else go to src3
    var try2 = (src2 && src2 !== src1) ? src2 : "";
    var try3 = (src3 && src3 !== src1 && src3 !== src2) ? src3 : "";

    // If current is src1, we try alternatives. If current already equals src2/src3, we just verify it.
    var startWith = current && current !== src1 ? current : src1;

    // Verify current first; if it fails, try fallbacks.
    probe(startWith, function (okCurrent) {
      if (okCurrent) return;

      probe(try2, function (ok2) {
        if (ok2) {
          img.src = try2;
          return;
        }

        probe(try3, function (ok3) {
          if (ok3) {
            img.src = try3;
            return;
          }

          // nothing worked -> show bg-color only
          img.style.display = "none";
        });
      });
    });
  }

  // Run on DOM ready for existing swatch imgs
  function initSwatchFallbacks() {
    var imgs = document.querySelectorAll(".mh-rsc-product-card__swatch-img[data-src1]");
    for (var i = 0; i < imgs.length; i++) fixOneSwatchImg(imgs[i]);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initSwatchFallbacks);
  } else {
    initSwatchFallbacks();
  }

  // If your theme loads cards via AJAX (infinite scroll), you can call:
  // window.mhRscRefreshSwatches && window.mhRscRefreshSwatches();
  window.mhRscRefreshSwatches = initSwatchFallbacks;

})();
  } catch(e) { console.error(e); }
})();

})();
